import * as React from 'react';
import type { SVGProps } from 'react';
const SvgIconsElse = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={41}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="var(--color-surface-base-primary)"
      stroke="var(--color-border-base-secondary)"
      d="M12 .5h17c1.877 0 2.758.002 3.486.117a9.5 9.5 0 0 1 7.897 7.897c.115.728.117 1.609.117 3.486s-.002 2.758-.117 3.486a9.5 9.5 0 0 1-7.897 7.897c-.728.115-1.609.117-3.486.117H12c-1.877 0-2.758-.002-3.486-.117a9.5 9.5 0 0 1-7.897-7.897C.502 14.758.5 13.877.5 12s.002-2.758.117-3.486A9.5 9.5 0 0 1 8.514.617C9.242.502 10.123.5 12 .5Z"
    />
    <path
      fill="var(--color-content-base-primary)"
      d="M9.927 16.3V7.571h5.676v1.326h-4.095v2.369h3.8v1.325h-3.8v2.382h4.129V16.3zm8.763-8.728V16.3h-1.542V7.572zm6.76 3.912-1.406.154c-.12-.43-.495-.819-1.206-.819-.644 0-1.134.307-1.13.75-.004.38.26.61.925.759l1.117.239c1.235.268 1.836.84 1.84 1.772-.004 1.24-1.159 2.088-2.795 2.088-1.607 0-2.617-.711-2.808-1.913l1.504-.145c.132.588.592.895 1.3.895.733 0 1.218-.337 1.218-.784 0-.37-.28-.614-.882-.746l-1.116-.234c-1.257-.26-1.845-.89-1.841-1.845-.004-1.21 1.07-1.986 2.646-1.986 1.534 0 2.42.707 2.634 1.815m4.31 4.943c-1.973 0-3.179-1.308-3.179-3.362 0-2.02 1.223-3.396 3.098-3.396 1.611 0 2.992 1.01 2.992 3.307v.473h-4.56c.013 1.12.673 1.777 1.67 1.777.665 0 1.177-.29 1.386-.844l1.44.162c-.273 1.138-1.321 1.883-2.847 1.883m-1.645-4.018h3.077c-.009-.89-.605-1.538-1.491-1.538-.92 0-1.539.703-1.586 1.538"
    />
  </svg>
);
export default SvgIconsElse;
